// extracted by mini-css-extract-plugin
export default {"container":"T03_my-qna_container__+Ea+1","limiter":"T03_my-qna_limiter__HiZ5m"};